
import { MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-50 to-gray-100 border-t">
      <div className="container mx-auto px-6 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <MessageSquare className="h-5 w-5 text-primary" />
              <span className="font-bold text-lg">OfferChat</span>
            </div>
            <p className="text-gray-600 text-sm">
              Transform customer engagement with AI-powered solutions that connect your business with your customers.
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Solutions</h3>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li><Link to="/" className="hover:text-primary">AI Chatbots</Link></li>
              <li><Link to="/" className="hover:text-primary">CRM Integration</Link></li>
              <li><Link to="/" className="hover:text-primary">Outbound Call Handling</Link></li>
              <li><Link to="/" className="hover:text-primary">Live Rep Connection</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Resources</h3>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li><Link to="/" className="hover:text-primary">Knowledge Base</Link></li>
              <li><Link to="/" className="hover:text-primary">Blog</Link></li>
              <li><Link to="/" className="hover:text-primary">Documentation</Link></li>
              <li><Link to="/" className="hover:text-primary">API Guides</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Company</h3>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li><Link to="/" className="hover:text-primary">About Us</Link></li>
              <li><Link to="/" className="hover:text-primary">Contact</Link></li>
              <li><Link to="/" className="hover:text-primary">Privacy Policy</Link></li>
              <li><Link to="/" className="hover:text-primary">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 text-sm">© {new Date().getFullYear()} OfferChat. All rights reserved.</p>
          <div className="mt-4 md:mt-0">
            <Link to="/portal/auth" className="text-primary hover:text-primary/80 font-medium">
              Login / Sign Up
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
